/* eslint-disable vue/no-v-html */
<template>
  <div>
    <div class="row">
      <div class="col-12">
        <!-- <u-help-text
          help-id="altTextHelp"
          help-title="Information"
          class="float-right"
        >
          <p>Zusätzliche Texte können in allen Textblöcken mit einer eckigen Klammer verwendet werden, z.b. <b>[Zusatz_1]</b>.</p>
          <p>Variablen können in allen Textblöcken mit einer geschweiften Klammer verwendet werden, z.b. <b>{NameDerVariable}</b>.</p>
        </u-help-text> -->
      </div>
    </div>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
      class="mr-4"
    />
    <u-loader v-if="isLoading" />
    <div
      v-for="(resultVariableText, resultVariableIndex) in textBlocks"
      v-else
      :key="resultVariableIndex"
      class="mb-4 mt-4 mr-4"
    >
      <div class="row mb-2">
        <h4
          v-if="editTextId != resultVariableText.id"
          class="col-11"
        >
          {{ resultVariableIndex + 1 }}
        </h4>
        <div
          v-if="editTextId != resultVariableText.id"
          class="col-1"
        >
          <button
            v-if="canUserEdit"
            v-b-modal.deleteAltText
            v-b-tooltip.hover
            class="btn btn-danger smallActionButton float-right mr-1 ml-1"
            placement="bottom"
            title="Textblock löschen"
            type="button"
            @click="textToDelete = resultVariableText.id"
          >
            <i class="fas fa-trash-alt" />
          </button>
          <button
            v-if="canUserEdit"
            v-b-tooltip.hover
            class="btn btn-primary smallActionButton float-right"
            placement="bottom"
            title="Textblock bearbeiten"
            type="button"
            @click="editTextId = resultVariableText.id"
          >
            <i class="fas fa-edit" />
          </button>
        </div>
        <div
          v-else
          class="col-10"
        />
      </div>
      <div
        v-show="editTextId != resultVariableText.id"
        class="row"
      >
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="isLanguageEnabled('de-CH')"
          class="col-sm"
        >
          <h5>Deutsch</h5>
          <p
            v-html="
              getContentForLanguage(
                resultVariableText.contents,
                'de-CH',
                'text',
                '',
              )
            "
          />
        </div>
        <div
          v-if="isLanguageEnabled('fr-CH')"
          class="col-sm"
        >
          <h5>Französisch</h5>
          <p
            v-html="
              getContentForLanguage(
                resultVariableText.contents,
                'fr-CH',
                'text',
                '',
              )
            "
          />
        </div>
        <div
          v-if="isLanguageEnabled('it-CH')"
          class="col-sm"
        >
          <h5>Italienisch</h5>
          <p
            v-html="
              getContentForLanguage(
                resultVariableText.contents,
                'it-CH',
                'text',
                '',
              )
            "
          />
        </div>
      </div>
      <div
        v-show="editTextId == resultVariableText.id"
        class="row"
      >
        <div
          v-if="isLanguageEnabled('de-CH')"
          class="col-sm"
        >
          <h5>Deutsch</h5>
          <div style="display: grid">
            <div
              class="ml-auto"
              style="font-size: 25px"
            >
              <i
                v-b-tooltip.hover
                class="fas fa-language"
                placement="bottom"
                title="Wert für alle Sprachen übernehmen"
                type="button"
                @click="
                  setAllLanguageTexts(
                    resultVariableText.contents,
                    'de-CH',
                    'text',
                  )
                "
              />
            </div>
          </div>
          <tiny-mce-editor
            :value="
              getContentForLanguage(
                resultVariableText.contents,
                'de-CH',
                'text',
                '',
              )
            "
            @input="updateContent(resultVariableText, 'de-CH', $event, 'text')"
          />
        </div>
        <div
          v-if="isLanguageEnabled('fr-CH')"
          class="col-sm"
        >
          <h5>Französisch</h5>
          <div style="display: grid">
            <div
              class="ml-auto"
              style="font-size: 25px"
            >
              <i
                v-b-tooltip.hover
                class="fas fa-language"
                placement="bottom"
                title="Wert für alle Sprachen übernehmen"
                type="button"
                @click="
                  setAllLanguageTexts(
                    resultVariableText.contents,
                    'fr-CH',
                    'text',
                  )
                "
              />
            </div>
          </div>
          <tiny-mce-editor
            :value="
              getContentForLanguage(
                resultVariableText.contents,
                'fr-CH',
                'text',
                '',
              )
            "
            @input="updateContent(resultVariableText, 'fr-CH', $event, 'text')"
          />
        </div>
        <div
          v-if="isLanguageEnabled('it-CH')"
          class="col-sm"
        >
          <h5>Italienisch</h5>
          <div style="display: grid">
            <div
              class="ml-auto"
              style="font-size: 25px"
            >
              <i
                v-b-tooltip.hover
                class="fas fa-language"
                placement="bottom"
                title="Wert für alle Sprachen übernehmen"
                type="button"
                @click="
                  setAllLanguageTexts(
                    resultVariableText.contents,
                    'it-CH',
                    'text',
                  )
                "
              />
            </div>
          </div>
          <tiny-mce-editor
            :value="
              getContentForLanguage(
                resultVariableText.contents,
                'it-CH',
                'text',
                '',
              )
            "
            @input="updateContent(resultVariableText, 'it-CH', $event, 'text')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-2 font-weight-bold mt-4">
          Tenant
        </div>
        <div
          v-if="editTextId == resultVariableText.id"
          class="col-4"
        >
          <v-select
            v-model="resultVariableText.tenantId"
            :items="tenants"
            item-text="bezeichnung"
            item-value="id"
          />
        </div>
        <div
          v-else
          class="col-4 mt-4"
        >
          {{
            tenants.filter((tenant) => {
              return tenant.id == resultVariableText.tenantId;
            })[0].bezeichnung
          }}
        </div>
      </div>
      <div class="row">
        <div class="col-2 font-weight-bold mt-4">
          Alternativtext Anzeigeoption
        </div>
        <div
          v-if="editTextId == resultVariableText.id"
          class="col-4"
        >
          <v-select
            v-model="resultVariableText.showTextWhen"
            :items="alternativeTextConditions"
            item-text="name"
            item-value="value"
          />
        </div>
        <div
          v-else
          class="col-4 mt-4"
        >
          {{
            alternativeTextConditions.filter((condition) => {
              return condition.value == resultVariableText.showTextWhen;
            })[0].name
          }}
        </div>
      </div>
      <div
        v-if="
          resultVariableText.showTextWhen == 3 &&
            editTextId == resultVariableText.id
        "
        class="row"
      >
        <!-- Filter CritertiaManagement START-->
        <div class="col-12">
          <label class="font-weight-bold my-3 largeSectionTitle">Filter</label>
        </div>

        <div
          v-for="(
            filterGroup, index
          ) in resultVariableText.alternativTextGroupFilters"
          :key="index"
          class="w-100"
        >
          <div class="grouped-filters">
            <div class="group-title">
              AND-Gruppe
            </div>

            <button
              v-if="canUserEdit"
              v-b-tooltip.hover
              class="btn btn-danger actionButton mt-2 ml-4"
              placement="bottom"
              title="And-Gruppe löschen"
              type="button"
              @click="
                deleteFilterGroup(
                  resultVariableText.alternativTextGroupFilters,
                  index,
                )
              "
            >
              <i class="fas fa-trash-alt" />
            </button>

            <div
              v-for="(filter, filterIndex) in filterGroup.filters"
              :key="filter.id + '_' + filterIndex"
              class="col-12 d-flex"
            >
              <criteria-groups-filter
                v-model="filterGroup.filters[filterIndex]"
                :contract-id="contractId"
                :edition-id="editionId"
                :readonly="!canUserEdit"
                :version-id="versionId"
                class="col-12"
              />
              <div>
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn btn-danger deleteFilterActionButton"
                  placement="bottom"
                  title="Diesen Filter löschen"
                  type="button"
                  @click="removeListItem(filterGroup.filters, filterIndex)"
                >
                  <i class="fas fa-trash-alt" />
                </button>
              </div>
            </div>
            <button
              v-if="canUserEdit"
              v-b-tooltip.hover
              class="btn btn-success smallActionButton mt-2 ml-4"
              placement="bottom"
              title="Neuer Filter hinzufügen"
              type="button"
              @click="addNewFilterItem(filterGroup.filters)"
            >
              <i class="fas fa-plus" />
            </button>
          </div>
          <div
            v-if="
              index + 1 < resultVariableText.alternativTextGroupFilters.length
            "
            class="or-label my-4 d-flex"
          >
            OR
          </div>
        </div>

        <div class="w-100">
          <button
            v-if="canUserEdit"
            v-b-tooltip.hover
            class="btn d-block btn-success float-right actionButton mr-4"
            placement="bottom"
            title="weitere AND-Gruppe hinzufügen"
            type="button"
            @click="addNewFilterGroup(resultVariableText)"
          >
            <i class="fas fa-plus" />
          </button>
        </div>
        <!-- Filter CritertiaManagement  END -->
      </div>

      <div
        v-show="editTextId == resultVariableText.id"
        class="row mt-3 mb-4"
      >
        <div class="col-12">
          <b-button
            v-b-tooltip.hover
            name="saveVersionEditionDetails"
            placement="bottom"
            title="Alle Sprachen werden gespeichert"
            type="submit"
            variant="success"
            @click="saveTextBlock(resultVariableText)"
          >
            Speichern
          </b-button>
          <b-button
            v-b-tooltip.hover
            class="ml-2"
            placement="bottom"
            title="Alle nicht gespeichert Änderungen dieses Textblockes gehen verloren"
            variant="danger"
            @click="editTextId = -1"
          >
            Abbrechen
          </b-button>
        </div>
      </div>
      <hr class="my-4">
    </div>
    <button
      v-if="
        textBlocks.filter((textblock) => {
          return textblock.id == 0;
        }).length == 0 && canUserEdit
      "
      id="addNewTextBlockButton"
      v-b-tooltip.hover
      class="btn btn-success float-right mr-4"
      placement="bottom"
      title="Neuer Text"
      type="button"
      @click="addNewTextBlock()"
    >
      <i class="fas fa-plus" />
    </button>
    <b-modal
      id="deleteAltText"
      ref="deleteAltText"
      hide-footer
      no-fade
      title="Textblock löschen"
    >
      <div class="d-block mb-4">
        Sind Sie sicher, dass Sie diesen Textblock löschen möchten?
      </div>
      <b-button
        variant="success"
        @click="deleteTextBlock()"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal('deleteAltText')"
      >
        Abbrechen
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import {
  LoadAllTextBlocks,
  SaveTextBlock,
  AddNewTextBlock,
  DeleteTextBlock,
} from "@/services/minimum.wage.services/alternativeTexts.minimum.wages.js";
import CriteriaGroupsFilter from "@/components/minimum.wage/pages/CriteriaGroups/CriteriaGroupsFilter.vue";
import { MultiLangMixin } from "@/mixins/MultilanguageContentsMixin";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";
import { StammdatenMixin } from "@/mixins/StammdatenMixin";
import TinyMceEditor from "@/components/common/tinyMceEditor.vue";

export default {
  components: {
    CriteriaGroupsFilter,
    TinyMceEditor,
  },
  mixins: [MultiLangMixin, MinimumWageMixin, StammdatenMixin],
  data() {
    return {
      isLoading: false,
      errorObject: null,
      activeTab: 0,
      textBlocks: [],
      originalTextBlocks: [],
      testObject: null,
      editTextId: -1,
      languages: ["de-CH", "fr-CH", "it-CH"],
      alternativeTextConditions: [
        { value: 1, name: "Anzeigen Lohn 0.-" },
        { value: 2, name: "Immer anzeigen" },
        { value: 3, name: "Wenn Regel(n) zutreffen" },
      ],
      tenants: [],
    };
  },
  watch: {
    editTextId(newValue) {
      if (newValue != 0) {
        this.textBlocks = JSON.parse(JSON.stringify(this.originalTextBlocks));
      }
    },
  },
  created() {
    this.loadAllTextBlocks();
    this.loadTenants();
    this.loadTranslatedLanguages();
    setTimeout(() => {
      this.loadTranslatedLanguages();
    }, "1000");
  },
  methods: {
    loadTranslatedLanguages() {
      if (
        this.$store.state.mindestLohnKonfiguration.BasicContractInformation
          .translatedLanguages
      ) {
        this.languages = [];
        this.$store.state.mindestLohnKonfiguration.BasicContractInformation.translatedLanguages.forEach(
          (translatedLanguage) => {
            this.languages.push(translatedLanguage.language);
          },
        );
      }
    },
    isLanguageEnabled(language) {
      for (var enabledLanguage of this.languages) {
        if (enabledLanguage == language) {
          return true;
        }
      }

      return false;
    },
    // Criteriagroup functions Start
    addNewFilterGroup(criteria) {
      var newGroup = {
        id: 0,
        alternativTextId: criteria.id,
        filters: [],
      };
      this.addNewFilterItem(newGroup.filters);
      criteria.alternativTextGroupFilters.push(newGroup);
    },
    addNewFilterItem(list) {
      list.push({
        id: 0,
        operator: 1,
        criteriaStructureId: -1,
        value: "",
        order: 0,
      });
    },
    deleteFilterGroup(collection, index) {
      collection.splice(index, 1);
    },
    removeListItem(collection, index) {
      collection.splice(index, 1);
    },

    // Critteriagroup functions End
    setAllLanguageTexts(contents, language, propertyName) {
      var contentToCopy = contents.filter((c) => {
        return c.language == language;
      });

      if (contentToCopy[0]) {
        contents.map((content) => {
          content[propertyName] = contentToCopy[0][propertyName];
        });
      }
    },
    hideModal(modalId) {
      this.$refs[modalId].hide();
    },

    loadAllTextBlocks() {
      this.isLoading = true;
      this.errorObject = null;

      LoadAllTextBlocks(
        this.contractId,
        this.versionId,
        this.editionId,
        (response) => {
          this.isLoading = false;
          this.textBlocks = JSON.parse(JSON.stringify(response));
          this.originalTextBlocks = JSON.parse(JSON.stringify(response));
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    addNewTextBlock() {
      var newTextBlock = {
        id: 0,
        code: "Neuer Textblock",
        configurationId: 0,
        tenantId: 1,
        showTextWhen: 1,
        alternativTextGroupFilters: [],
        contents: [
          {
            id: 0,
            textblockId: 0,
            text: "",
            description: "",
            value: "de",
            language: "de-CH",
          },
          {
            id: 0,
            textblockId: 0,
            text: "",
            description: "",
            value: "fr",
            language: "fr-CH",
          },
          {
            id: 0,
            textblockId: 0,
            text: "",
            description: "",
            value: "it",
            language: "it-CH",
          },
        ],
      };

      this.textBlocks.push(JSON.parse(JSON.stringify(newTextBlock)));
      setTimeout(() => {
        this.editTextId = 0;
      }, 50);
    },
    updateContent(textBlock, language, content, propertyName) {
      textBlock.contents.find((item) => item.language === language)[
        propertyName
      ] = content;
    },
    saveTextBlock(textBlockToSave) {
      this.isLoading = true;
      this.errorObject = false;

      if (textBlockToSave.id != 0) {
        SaveTextBlock(
          this.contractId,
          this.versionId,
          this.editionId,
          textBlockToSave,
          () => {
            this.editTextId = -1;
            this.loadAllTextBlocks();
          },
          (error) => {
            this.errorObject = error;
            this.isLoading = false;
          },
        );
      } else {
        AddNewTextBlock(
          this.contractId,
          this.versionId,
          this.editionId,
          textBlockToSave,
          () => {
            this.editTextId = -1;
            this.loadAllTextBlocks();
          },
          (error) => {
            this.errorObject = error;
            this.isLoading = false;
          },
        );
      }
    },
    deleteTextBlock() {
      this.isLoading = true;
      this.errorObject = false;

      DeleteTextBlock(
        this.contractId,
        this.versionId,
        this.editionId,
        this.textToDelete,
        () => {
          this.editTextId = -1;
          this.hideModal("deleteAltText");
          this.loadAllTextBlocks();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style>
.alternativeTextTabControl .shadow-sm {
  border-top: none;
  border-radius: 0px;
}
</style>

<style scoped>
.smallActionButton {
  width: 30px;
  height: 30px;
  font-size: 17px;
  padding: 0px;
}

.or-label {
  font-weight: bold;
  margin: 10px 10px;
  font-size: 1.3rem;
}

.grouped-filters {
  border: 1px solid rgb(160, 160, 160);
  padding: 15px 0px 20px;
  margin-left: 5px;
  width: calc(100% - 10px);
  position: relative;
}

.group-title {
  color: gray;
  position: absolute;
  top: -12px;
  left: 20px;
  background-color: white;
  padding: 0px 10px;
}

.largeSectionTitle {
  font-size: 1.4rem;
}

.actionButton {
  height: 34px;
  margin-top: 15px;
  margin-left: 10px;
}

.smallActionButton {
  width: 25px;
  height: 25px;
  font-size: 17px;
  padding: 0px;
}

.deleteFilterActionButton {
  height: 34px;
  margin-top: 15px;
  margin-left: 3px;
}

.configurationWrapper {
  border-bottom: 1px solid rgb(59, 59, 59);
}

.criterionTitle {
  font-size: 1.2rem;
  cursor: pointer;
  font-weight: bold;
  border-bottom: 1px solid rgb(235, 235, 235);
  padding: 7px;
}

.width20 {
  width: 20px;
}

.criteriaContent {
  overflow: hidden;
  max-height: 3500px;
}

.accordion-enter-active {
  transition: 1s;
}

.accordion-leave-active {
  transition: 0.2s;
}

.accordion-enter {
  max-height: 0px;
}

.accordion-leave-to {
  max-height: 0px;
}

.verticalAlignCenter {
  line-height: 57px;
}

.deleteCriteriaButton {
  position: absolute;
  right: 10px;
  top: 6px;
  width: 30px;
  height: 30px;
  padding: 0;
}
</style>
